<template>
  <div id="tranNum">
    <div class="d-flex pt-2 pl-2">
      <router-link to='/technology'>
         <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff;font-weight: bold">科技型企业入库</span>
        </span>
      </router-link>
    </div>
    <!--      <div class="item">-->
    <!--        <span><i class="icon-dot" style="color: #ed3f35"></i>技术交易金额</span>-->
    <!--        <h2>{{toThousands(allAmount)}}</h2>元-->
    <!--      </div>-->

    <div class="d-flex clearfix" style="text-align: center;justify-content: center;width: 100%;margin-top: 0.2rem;width: 100%;height: 90%;
">
      <Echart
          id="tranNumChart3"
          :options="options"
          height="100%"
          width="100%"
      ></Echart>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'
// import sciApi from '@/api/index.js'
// import moment from 'moment'
let Chart
export default {
  data () {
    return {
      options: {},
      allAmount:0,
      tag: '',
      ach:[],
      sum: 0,
      Num:{
        '2016':0,
        '2017':0,
        '2018':0,
        '2019':0,
        '2020':0,
        '2021':0,
        '2022':0,
      },
      time:[],
      money:[],
      month: [],
      tagList:{}
    }
    // 通过率和达标率的组件复用数据
  },
  watch: {
    setregion1: {
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val
      }
    },
    setData: {
      immediate: true,
      deep: true,
      handler(val) {
        this.tagList=val
        this.init().then(()=>{
          let num=[]
          let tum=[]
          for(var i=0;i<this.month.length;i++){
            num.push(this.month[i].year)
            tum.push(this.month[i].num||0)
          }
          this.options.xAxis.data=num
          this.options.series[0].data=tum
          Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
        });
        // if(!Chart.clear) return
        // Chart.clear()
      }
    },
  },
  computed: {
    setregion1() {
      // console.log(this.$store.state.region)
      return this.$store.state.region1
    },
    setData() {
      // console.log(this.$store.state.carList,'this.$store.state.carList')
      return this.$store.state.carList
    },
  },
  mounted() {
    this.tag = ''
    // window.addEventListener("resize",function(){
    //   this.Chart.resize();})
    this.init().then(()=>{
      let num=[]
      let tum=[]
      for(var i=0;i<this.month.length;i++){
          num.push(this.month[i].year)
          tum.push(this.month[i].num||0)
      }
      this.options.xAxis.data=num
      this.options.series[0].data=tum
      Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    });
    //当前视口宽度
    let nowClientWidth = document.documentElement.clientWidth;
    // 换算方法
    let nowSize = function (val, initWidth = 1920) {
      return val * (nowClientWidth / initWidth);
    };
    // const chartTit = Object.keys(this.Num);
    this.options = {
      // color:[
      //   '#5efffa',
      //   '#339be9',
      //   '#fa7c36',
      //   '#fe7c85',
      //   '#ec515c',
      //   '#ffd663',
      //   '#fbc01b',
      //   '#ab8fff',
      //   '#8762f3'
      // ],
      tooltip: {
        // 触发类型  经过轴触发axis  经过轴触发item
        trigger: 'item',
        // 轴触发提示才有效
        axisPointer: {
          // 默认为直线，可选为：'line' 线效果 | 'shadow' 阴影效果
          type: 'shadow'
        }
      },
      grid: {
        // 距离 上右下左 的距离
        left: '3%',
        right: '3%',
        bottom: '1%',
        top:'15%',
        // 大小是否包含文本【类似于boxsizing】
        containLabel: true,
        //显示边框
        show: false,
        //边框颜色
        borderColor: 'rgba(0, 240, 255, 0.3)'
      },
      xAxis: {
        // 使用类目，必须有data属性

        // 使用 data 中的数据设为刻度文字
        type: 'category',
        data:[],
        // 刻度设置
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false
        },
        axisLine:{
          show:true,
          lineStyle:{
            color:'#fff'
          },

        },
        //文字
        axisLabel: {
          color: '#fff',
          fontSize: nowSize(14),
          // interval: 0,
          // rotate: 30
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#fff',
            show:true
          }
        }
      },
      yAxis: {
        type: 'value',
        boundaryGap:false,
        // 使用数据的值设为刻度文字
        name: "单位（家）",
        nameTextStyle: {
          nameLocation: "start",
        },
        axisTick: {
          // true意思：图形在刻度中间
          // false意思：图形在刻度之间
          alignWithLabel: false,
          show: false

        }, //坐标线
        axisLine:{
          show:true,
          lineStyle:{
            color:'#fff'
          }},
        //文字
        axisLabel: {
          color: '#fff',
          fontSize: nowSize(14),
        },
        splitLine: {
          show:false,
          lineStyle: {
            color: '#fff',
            show:true
          }
        },
      },
      series: [{
        barWidth: 30,
        // lineStyle: {
        //   color: '#4c9bfd',
        //   width: 2
        // },
        itemStyle: {
          normal: {
            // barBorderRadius:5,
            color:function (params) {
              var colorList=[
                '#5efffa',
                '#339be9',
                '#fa7c36',
                '#fe7c85',
                '#ec515c',
                '#ffd663',
                '#fbc01b',
                '#ab8fff',
                '#8762f3'
              ]
              if (params.dataIndex >= colorList.length) {
                params.dataIndex = params.dataIndex - colorList.length
              }
              return colorList[params.dataIndex]
            }
            // type: 'linear',
            // color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
            //   // { offset: 0, color: "#956FD4" },
            //   // { offset: 1, color: "#3EACE5" }
            //   { offset: 0, color: '#14c8d4'}, // 1 结束颜色
            //   { offset: 1, color: '#43eec6' }  // 0 起始颜色
            // ])
          }
        },
        label: {
          show: true,
          position: 'top',
          color:'#4c9bfd',
          formatter: "{text|{c}}",
          rich: {
            text: {
              fontSize: nowSize(16),
              color: '#fff',
            }
          }
        },
        data: [],
        type: 'bar'
      }]
    };
    this.drawLine()
  },
  components: {
    Echart
  },
  methods: {
    toThousands(num) {
      return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    },
    async init() {
      // const that = this;
      // await sciApi.selectSubjects({level1:"491924081119699001",level2:"491924081119699060",pageSize: 1000,pageNum: 1}).then((data) => {
        this.month = this.tagList.keQiCount || []
      //   this.allAmount=0
      //   // if(this.tag!==''){
      // this.month.forEach((item) => {
      //   this.Num[item.year]=item
      // })
        // }
        // else {
        //   this.month.forEach((item) => {
        //     that.Num[item.policyLevel3Value] += parseInt(item.mapNum);
        //   })
        // }
        // this.month.forEach((item) => {
        //   this.allAmount+= parseInt(item.totalPrices);
        //   let tit = moment(item.orderCreateTime).format('M')+'月'
        //   that.Num[tit] += parseInt(item.totalPrices);
        //  })
      // })

    },
    drawLine: function () {
      Chart = this.$echarts.init(document.getElementById('tranNumChart3'))
      Chart.setOption(JSON.parse(JSON.stringify(this.options)));
      // option && myChart.setOption(option);
    },
  }
};
</script>

<style lang="scss">
#tranNum {
  width: 100%;
  height: 100%;
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    //justify-content: space-around;
  }
  .item{
    width: 100%;
    font-size: 16px;
    color: #5cd9e8;
    text-align: left;
    line-height: 40px;
    padding-left: 0.2rem;
  }
  .item h2{
    font-size: 30px;
    color:#fff!important;
    display: inline-block;
    //font-weight: normal;
    padding: 0 0.1rem;
  }
  .down {
    padding: 0.07rem 0.05rem;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: 3.1875rem;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 0.0625rem;
    }

  }
}
</style>